import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import {   
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
    Input,
    InputGroup, } from "reactstrap";
import { Link } from 'react-router-dom';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import { EXIT_HANDOVER, EMPLOYEES } from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

    const Handover = () => {
        const [empNo, setEmpNo] = useState('');
        const [empName, setEmpName] = useState('');
        const [empTitle, setEmpTitle] = useState('');
        const [savedHandover, setSavedHandover] = useState([])
        toastr.options = TOAST_OPTIONS;

        useEffect(()=>{
            if (localStorage.getItem("authUser")) {
                const obj = JSON.parse(localStorage.getItem("authUser"));
                const EmployeeNo = obj.uid; 
                axios.get(EMPLOYEES + "?$filter=No eq '"+ EmployeeNo +"'", HRConfig)
                    .then(function(response){
                        if(response.data.value.length > 0){
                            setEmpNo(response.data.value[0].No);
                            setEmpName(response.data.value[0].FirstName + " " + response.data.value[0].MiddleName+ " " + response.data.value[0].LastName);
                            setEmpTitle(response.data.value[0].JobTitle);
                        }else{
                            toastr.error("Employee Details Not Found in Business Central");
                        }
                    }).catch(function (error) {
                        //toastr.error(error.response.data.message);
                        console.log(error);
                    })
                    .then(function () {
                    // always executed
                });
                axios.get(`${EXIT_HANDOVER}?$filter=EmployeeNo eq '${EmployeeNo}'`, HRConfig).then((r)=>{ console.log(r); setSavedHandover(r.data.value); }).catch((e)=>{ console.log(e); })
            }
        },[])

        const handleSaveHandover = () => {
            const data = {
                "Date"              : formatDate(document.getElementsByClassName("EndDateOfService")[0]._flatpickr.selectedDates[0]),
                "EmployeeNo"        : empNo,
                "EndDateOfServices" : document.getElementsByClassName("EndDateOfService")[0].value,
                //"SupervisorNo"      : 
                //"SupervisorName"    :
                "OfficialDocumentsHandedIn" : document.getElementsByClassName("OfficialDocumentsHandedIn")[0].value,
                "EquipMachFurnSurrendered"  : document.getElementsByClassName("EquipMachFurnSurrendered")[0].value,
                "HandoverReportSubmitted"   : document.getElementsByClassName("HandoverReportSubmitted")[0].value, 
                "HandoverReportRemarks"     : document.getElementsByClassName("HandoverReportRemarks")[0].value,
                //"ICTManagerNo":
                //"ICTManagerName":
                //"ICTEquipReturned":
                //"CanAccessOfficeFacilities":
                //"StillOnTheNetworkDomain":
                //"CanAccessUMCS":
                //"ICTEquipRemarks":
                //"ClearedOutstandingBalance":
                //"ClearanceRemarks": 
            }
            axios.post(`${EXIT_HANDOVER}`, JSON.stringify(data), HRConfig).then((r)=>{ console.log(r); }).catch((e)=>{ console.log(e); })
        }
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Staff Handover | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Handover" />
                        
                        {(savedHandover.length < 1) &&(
                            <>
                                <Row>
                                    <Col lg={5}>
                                    <Card>
                                        <CardBody>
                                        

                                        
                                        <Row>
                                        
                                            <Col md={6}>
                                                <div className="mb-3">
                                                <Label htmlFor="formrow-email-Input">Employee No</Label>
                                                <Input
                                                    type="text"
                                                    className="form-control employeeNo"
                                                    defaultValue={empNo}
                                                    disabled={true}
                                                />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                <Label htmlFor="formrow-email-Input">Employee Name</Label>
                                                <Input
                                                    type="text"
                                                    className="form-control employeeName"
                                                    defaultValue={empName}
                                                    disabled={true}
                                                />
                                                </div>
                                            </Col>
                                            </Row>
                                            <Row>
                                            
                                            <Col md={12}>
                                                <div className="mb-3">
                                                <Label htmlFor="formrow-email-Input">Position</Label>
                                                <Input
                                                    type="text"
                                                    className="form-control position"
                                                    defaultValue={empTitle}
                                                    disabled={true}
                                                />
                                                </div>
                                            </Col>
                                        
                                            </Row>
                                        </CardBody>
                                        </Card>
                                    <Card>
                                        <CardBody>
                                        

                                        <Form>

                                            <Row>
                                            <Col md={12}>
                                            <div className="mb-3">
                                            <Label htmlFor="formrow-firstname-Input">End of service with MILDMAY effective from:</Label>
                                    
                                            <Flatpickr
                                                id="floatingPlanningDateInput"
                                                className="form-control EndDateOfService"
                                                placeholder="dd M,yyyy"
                                                options={{
                                                    dateFormat: "Y-m-d"
                                                }}
                                          
                                                />
                                            </div>
                                            </Col>
                                            
                                            </Row>
                                            <div>
                                            </div>
                                        </Form>
                                        </CardBody>
                                    </Card>
                                    </Col>





                                    <Col lg={7}>
                                    <Card>
                                        <CardBody>
                                        <Form>
                                            <div className="mb-3">
                                            <Label htmlFor="formrow-firstname-Input"><b>(a). Have Official Documents and Materials been Handed in ? YES/NO</b></Label>
                                            <Input
                                                type="text"
                                                className="form-control OfficialDocumentsHandedIn"
                                            />
                                            </div>

                                            <div className="mb-3">
                                            <Label htmlFor="formrow-firstname-Input"><b>(b). What Official equipment, machines, furniture, etc have been surrended?</b></Label>
                                            <Input
                                                type="text"
                                                className="form-control EquipMachFurnSurrendered"
                                            />
                                            </div>

                                            <div className="mb-3">
                                            <Label htmlFor="formrow-firstname-Input"><b>(c). Has the Comprehensive report been submitted ? Yes/No</b></Label>
                                            <Input
                                                type="text"
                                                className="form-control HandoverReportSubmitted"
                                            />
                                            </div>

                                            <div className="mb-3">
                                            <Label htmlFor="formrow-firstname-Input"><b>(d).Remarks</b></Label>
                                            <Input
                                                type="text"
                                                className="form-control HandoverReportRemarks"
                                            />
                                            </div>

                                            
                                            
                                            <div>
                                            <Row>
                                            <Col md={6}>
                                            <div className="d-grid gap-2">
                                            <Button type="button" className="btn btn-success w-md" onClick={handleSaveHandover}>
                                                Save
                                            </Button>
                                            </div>
                                            </Col>
                                            <Col md={6}>
                                            <div className="d-grid gap-2">
                                            <Button type="button" className="btn btn-primary w-md" >
                                                Update
                                            </Button>
                                            </div>
                                            </Col>
                                            </Row>
                                            
                                            
                                            
                                            </div>
                                        </Form>
                                        </CardBody>
                                    </Card>
                                    </Col>
                        </Row> 
                        </>
                        )}
                        {(savedHandover.length > 0) &&(
                            <>
                            <Row>
                                <Col>
                                <Card outline color="success" className="border">
                                    <CardBody>
                                    <CardTitle className="mb-4 text-white">
                                        
                                    </CardTitle>
                                    
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                                        </div>
                                        <div>
                                        <h5>Submitted</h5>
                                        <p className="text-muted">
                                                Handover Data Submitted
                                        </p>
                                        </div>
                                    </div>
                                    <div className="text-center mt-4">
                                        <Link
                                        to="#"
                                        className="btn btn-primary  btn-sm"
                                        >
                                        View More <i className="mdi mdi-arrow-right ms-1" />
                                        </Link>
                                    </div>
                                    </CardBody>
                                </Card>
                                </Col>
                                </Row>
                            </>
                        )}


                    </Container>
                </div>
            </>
        );
    }

export default Handover;